import * as THREE from "three";
import type { SuntraceQuality } from "./types";

export type SuntraceImageDepthProfile = {
  enabled: boolean;
  resolutionScale: number;
  slices: number;
  stepsPerSide: number;
  maximumDarkening: number;
  maximumInscattering: number;
};

const highProfile = Object.freeze({
  enabled: true,
  resolutionScale: 0.5,
  slices: 2,
  stepsPerSide: 4,
  maximumDarkening: 0.18,
  maximumInscattering: 0.16,
});

const disabledProfile = Object.freeze({
  ...highProfile,
  enabled: false,
});

export const SUNTRACE_IMAGE_DEPTH_PROFILE: Readonly<
  Record<SuntraceQuality, SuntraceImageDepthProfile>
> = Object.freeze({
  high: highProfile,
  medium: disabledProfile,
  low: disabledProfile,
});

export const createSuntraceImageDepthProfile = (
  quality: SuntraceQuality,
): SuntraceImageDepthProfile => SUNTRACE_IMAGE_DEPTH_PROFILE[quality];

export const adaptSuntraceExposure = (
  current: number,
  target: number,
  deltaSeconds: number,
): number => {
  const safeCurrent = THREE.MathUtils.clamp(
    Number.isFinite(current) ? current : 1,
    0.45,
    1.85,
  );
  const safeTarget = THREE.MathUtils.clamp(
    Number.isFinite(target) ? target : 1,
    0.45,
    1.85,
  );
  const safeDeltaSeconds = Math.max(0, Number.isNaN(deltaSeconds) ? 0 : deltaSeconds);
  const speed = safeTarget > safeCurrent ? 3.2 : 1.1;
  const amount = 1 - Math.exp(-safeDeltaSeconds * speed);
  return THREE.MathUtils.lerp(safeCurrent, safeTarget, amount);
};
